<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 219.27 214"
    style="enable-background: new 0 0 219.27 214"
    fill="currentColor"
    :class="{
      [`fill-${color} h-${height} w-${width}`]: true,
    }"
    xml:space="preserve"
  >
    <g>
      <path
        class="st0"
        d="M51.31,195.59L9.13,209.06c-2.58,0.82-5.4,0.09-7.24-1.89c-1.85-1.97-2.39-4.84-1.4-7.35l16.45-41.67
		c-8.71-15.78-13.29-33.59-13.29-51.73c0-59.11,48.09-107.2,107.2-107.2c59.11,0,107.2,48.09,107.2,107.2
		c0,59.11-48.09,107.2-107.2,107.2C89.46,213.63,68.96,207.4,51.31,195.59z M17.64,106.43c0,16.78,4.51,33.24,13.05,47.59
		c1.11,1.86,1.29,4.13,0.5,6.15l-12.26,31.07l31.41-10.03c2.11-0.67,4.41-0.31,6.21,0.98c15.89,11.41,34.66,17.44,54.29,17.44
		c51.39,0,93.2-41.81,93.2-93.2c0-51.39-41.81-93.2-93.2-93.2C59.45,13.23,17.64,55.04,17.64,106.43z"
      />
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
    },
    height: {
      type: String,
    },
    width: {
      type: String,
    },
  },
};
</script>
